module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-up-0.aaa178a7.svg";